import { useTranslation } from 'react-i18next';

import { formatCalendarDay } from 'support/helpers/dateTime/dateTime';
import { DocumentType } from 'support/types';

import { useShipmentSummaryValues } from '../DocumentSummary/hooks/useShipmentSummary';
import { SummaryAccordion } from '../SummaryAccordion/SummaryAccordion';

export const CreateShipmentSummary = ({
  documentType,
}: {
  documentType: DocumentType.shippingNotice | DocumentType.dispatchResponse;
}) => {
  const { t } = useTranslation();
  const shipmentSummary = useShipmentSummaryValues();
  return (
    <SummaryAccordion
      header={{
        label: t('webedi:documentSummary.title', {
          documentType: t(`common:messageTypes.singular.${documentType}`),
        }),
        value: Math.round(shipmentSummary.totalQuantity),
        valueLabel: t('webedi:documentSummary.shipment.totalQuantity.label'),
      }}
      bodyItems={[
        {
          label: t('webedi:documentSummary.shipment.deliveryDate.label'),
          value: formatCalendarDay(shipmentSummary.deliveryDate) || '—',
        },
        {
          label: t('webedi:documentSummary.shipment.shippedLineItemCount.label'),
          value: Math.round(shipmentSummary.lineItemCount),
        },
      ]}
      footer={{
        label: t('webedi:documentSummary.shipment.totalQuantity.label'),
        value: Math.round(shipmentSummary.totalQuantity),
      }}
    />
  );
};

/**
 * i18n keys
 * t('common:messageTypes.singular.SHIPPING_NOTICE')
 * t('common:messageTypes.singular.DISPATCH_INSTRUCTION_RESPONSE')
 */
